import styled from '@mui/material/styles/styled';

export const StyledInputsContainer = styled('div')(({ theme }) => ({
  gridTemplateColumns: '1fr 1fr',
  display: 'grid',
  gap: theme.spacing(2),
  marginBottom: theme.spacing(2),
  '& > *': {
    display: 'grid',
    gridColumn: 'span 2',
    width: '100%',
  },
  '@container (width > 350px)': {
    '& > *': {
      gridColumn: 'span 1',
    },
  },
}));

export const StyledInputWrapperFull = styled('div')({
  // NOTE: Yes, !important is necessary here due to the @container rule above
  gridColumn: 'span 2 !important',
});

export const StyledButtonsWrapper = styled('div')(() => ({
  display: 'flex',
  flexWrap: 'wrap',
  gridGap: '8px',
  containerType: 'inline-size',
  '& > button': {
    maxWidth: '600px',
    width: '100%',
  },
  '@container (min-width: 600px)': {
    '& > button': {
      width: 'auto',
    },
  },
  '& > button:nth-last-of-type(2)': {
    marginRight: 'auto',
  },
}));

export const StyledModalButtonsWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  justifyContent: 'flex-end',
  marginTop: theme.spacing(3),
}));
